import './App.css';

import { persistor, store } from './redux/store';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { setUseWhatChange } from '@simbathesailor/use-what-changed';
import { ApolloProviderWrapper } from 'apollo/apollo-provider-wrapper';
import { PropertyProvider } from 'context/propertyContext';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { Main } from 'main';
import { Toaster } from 'react-hot-toast';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Toaster as ToasterSonner } from 'sonner';
import { UserProvider } from './features/users/context/userContext';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

setUseWhatChange(process.env.NODE_ENV === 'development');

export const App = () => {
	return (
		<ReduxProvider store={store}>
			<ApolloProviderWrapper>
				<UserProvider>
					<PersistGate loading={null} persistor={persistor}>
						<PropertyProvider>
							{/* @ts-ignore */}
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<Main />
								<Toaster />
								<ToasterSonner />
							</LocalizationProvider>
						</PropertyProvider>
					</PersistGate>
				</UserProvider>
			</ApolloProviderWrapper>
		</ReduxProvider>
	);
};
